export default __webpack_public_path__ + "images/4K.27b6cba.png";